// extracted by mini-css-extract-plugin
export default {"homeContent":"PageContentLayout_homeContent__+Zkzv","header":"PageContentLayout_header__AQ62p"};